(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/account-services/check-syndicate-terms.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/account-services/check-syndicate-terms.js');

'use strict';

const rulesAndTerms = svs.syndicate.rules_and_terms;
async function checkSyndicateTerms(_ref) {
  let {
    next,
    isSyndicate
  } = _ref;
  if (isSyndicate) {
    await rulesAndTerms.checkAndShowSyndicateTermsDialogAsync();
  }
  next();
}
svs.numbergames.pay_numbergames.checkSyndicateTerms = checkSyndicateTerms;

 })(window);